<template>
    <div class="printContentBox">
        <table class="printFormTable" v-html="htmlTable"></table>
        <table class="printSubTableHtml" v-for="(item,index) in subTableHtmlArray" v-html="item.subTableHtml" :key="index"></table>
        <table class="printRefFormTableHtml" v-for="(item,index) in refFormTableHtmlArray" v-html="item.refFormTableHtml" :key="index"></table>
        <table class="printApprovalFormTable" v-html="approvalHtmlTable" v-if="showApprovalInfo && formInfo.approvalRecordList && formInfo.approvalRecordList.length>0"></table>
    </div>
</template>

<script>
import { getModelFormReportList, getModelListByMainFormId } from '@/data-model';
export default {
    components: {
    },
    data () {
        return {
            htmlTable: '',
            approvalHtmlTable: '',
            subTableHtmlArray: [],
            refFormTableHtmlArray: []
        };
    },
    filters: {
    },
    props: {
        formInfo: {
            type: Object
        },
        showApprovalInfo: {
            type: Boolean,
            default: true
        }
    },
    created () {
        this.builderTable();
    },
    computed: {
    },
    watch: {
    },
    methods: {
        builderTable () {
            let fieldList = [];
            let subFormList = [];
            // 处理下拉隐藏显示的字段问题
            // 1.获取下拉字段和选项字段的值
            this.formInfo.fieldsList.forEach(item => {
                if (item.type === 'select') {
                    this.handelSelectVal(this.formInfo.values[item.id], item);
                }
                if (item.type === 'category' && item.options.config.type === 'single') {
                    this.handelSelectVal(this.formInfo.values[item.id], item);
                }
            });
            this.formInfo.fieldsList.forEach(element => {
                if (element.type !== 'divider' && element.type !== 'subform' && element.type !== 'divider' && element.type !== 'file' && element.type !== 'archive' && this.formInfo.values[element.id + '-casDefautShow'] !== false) {
                    fieldList.push(element);
                }
                if (element.type === 'subform') {
                    subFormList.push(element);
                }
            });
            let htmlTable = '<tr><td class="printFormName" colspan="' + (this.formInfo.colSpan * 2) + '">' + this.formInfo.formName + '</td></tr>';
            if (this.formInfo.colSpan === 1) { // 一行一列
                for (let i = 0; i < fieldList.length; i++) {
                    let cur = fieldList[i];
                    htmlTable += '<tr class="oneCells"><td class="tdLabel">' + cur.name + '</td><td>' + this.getFormValues(cur) + '</td></tr>';
                }
            } else if (this.formInfo.colSpan === 2) { // 一行两列
                let cacheTr = '';
                for (let i = 0; i < fieldList.length; i++) {
                    let index = i + 1;
                    let cur = fieldList[i];
                    if ((fieldList.length % 2) > 0 && (fieldList.length - 1) === i) {
                        cacheTr += '<td class="tdLabel">' + cur.name + '</td><td class="tdValue" colspan="3">' + this.getFormValues(cur) + '</td>';
                    } else {
                        cacheTr += '<td  class="tdLabel">' + cur.name + '</td><td class="tdValue">' + this.getFormValues(cur) + '</td>';
                    }
                    if (index % 2 === 0 || index === fieldList.length) {
                        htmlTable += '<tr class="twoCells">' + cacheTr + '</tr>';
                        cacheTr = '';
                    }
                }
            } else if (this.formInfo.colSpan === 3) { // 一行三列
                let cacheTr = '';
                for (let i = 0; i < fieldList.length; i++) {
                    let index = i + 1;
                    let cur = fieldList[i];
                    if ((fieldList.length % 3) > 0 && (fieldList.length - 1) === i) {
                        cacheTr += '<td class="tdLabel">' + cur.name + '</td><td class="tdValue" colspan="' + (((3 - (fieldList.length % 3)) * 2) + 1) + '">' + this.getFormValues(cur) + '</td>';
                    } else {
                        cacheTr += '<td  class="tdLabel">' + cur.name + '</td><td class="tdValue">' + this.getFormValues(cur) + '</td>';
                    }
                    if (index % 3 === 0 || index === fieldList.length) {
                        htmlTable += '<tr class="threeCells">' + cacheTr + '</tr>';
                        cacheTr = '';
                    }
                }
            }
            // 绘制子表单
            if (subFormList.length > 0) {
                this.subTableHtmlArray = [];
                subFormList.forEach(item => {
                    let tr = '<tr><td colspan="' + item.options.fieldList.length + '">' + item.name + '</td></tr>';
                    let tds = item.options.fieldList;
                    let td = '';
                    tds.forEach(element => {
                        td += '<td>' + element.label + '</td>';
                    });
                    tr += '<tr>' + td + '</tr>';
                    // 进行值的渲染
                    let sunTableValues = this.formInfo.values[item.id];
                    if (sunTableValues.length > 0) {
                        sunTableValues.forEach(obj => {
                            let subTd = '';
                            tds.forEach(cur => {
                                subTd += '<td>' + this.getSubFormValues(obj, cur) + '</td>';
                            });
                            tr += '<tr>' + subTd + '</tr>';
                        });
                        let subTableHtml = {subTableHtml: tr};
                        this.subTableHtmlArray.push(subTableHtml);
                    }
                });
            }
            // 绘制关联子表
            this.initModelListByRefFormIds(this.formInfo.formId);
            // 绘制审批流
            if (this.formInfo.approvalRecordList && this.formInfo.approvalRecordList.length > 0) { // 如果有审批，则显示出审批流
                let arrpovalTr = '<tr><td colspan="4">审批详情</td></tr>';
                arrpovalTr += '<tr><td width="80px;">#</td><td  width="240px;">审批人</td><td  width="120px;">审批状态</td><td>审批意见</td></tr>';
                for (let i = 0; i < this.formInfo.approvalRecordList.length; i++) {
                    let item = this.formInfo.approvalRecordList[i];
                    let approvalList = item.list;
                    let trueNameArray = [];
                    let resultArray = [];
                    let remarksArray = [];
                    if (approvalList && approvalList.length > 0) {
                        for (let j = 0; j < approvalList.length; j++) {
                            let cur = approvalList[j];
                            trueNameArray.push(cur.trueName);
                            if (cur.approvalResult === 0) {
                                resultArray.push('未处理');
                            } else if (cur.approvalResult === 1) {
                                resultArray.push('通过');
                            } else if (cur.approvalResult === 2) {
                                resultArray.push('驳回');
                            }
                            if (cur.approvalRemarks === undefined) {
                                cur.approvalRemarks = '';
                            }
                            if (cur.approvalDate === undefined) {
                                cur.approvalDate = '';
                            }
                            remarksArray.push(cur.approvalRemarks + ' ' + cur.approvalDate);
                        }
                    } else {
                        trueNameArray.push(item.trueName);
                        if (item.approvalResult === 0) {
                            resultArray.push('未处理');
                        } else if (item.approvalResult === 1) {
                            resultArray.push('通过');
                        } else if (item.approvalResult === 2) {
                            resultArray.push('驳回');
                        }
                        if (item.approvalRemarks === undefined) {
                            item.approvalRemarks = '';
                        }
                        if (item.approvalDate === undefined) {
                            item.approvalDate = '';
                        }
                        remarksArray.push(item.approvalRemarks + ' ' + item.approvalDate);
                    }
                    arrpovalTr += '<tr><td>' + (i + 1) + '审</td><td>' + trueNameArray.join(',') + '</td><td>' + resultArray.join(',') + '</td><td>' + remarksArray.join('|') + '</td></tr>';
                }
                this.approvalHtmlTable = arrpovalTr;
            }
            this.htmlTable = htmlTable;
        },
        async initModelListByRefFormIds (formId) {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let modelList = await getModelListByMainFormId(formId);
            if (modelList && modelList.length > 0) {
                modelList.forEach(async element => {
                    let params = {
                        formId: element.formId,
                        isFilterDuplicateData: false,
                        mainFormDataId: this.formInfo.values.id,
                        mainFormId: formId,
                        modelId: element.id,
                        modelType: undefined,
                        name: '',
                        searchCondition: '',
                        selectedApprovalStatus: '',
                        selectedFields: '',
                        currentPage:1,
                        pageSize:500
                    };
                    let formData = await getModelFormReportList(params);
                    let fieldsList = [];
                    let selectedFields = formData.otherData.selectedFields;
                    if (!selectedFields) { // 假如selectedFields为空，则取fieldsList的id
                        let fieldsList = formData.otherData.fieldsList;
                        let fieldsListids = [];
                        fieldsList.forEach(element => {
                            fieldsListids.push(element.id);
                        });
                        selectedFields = fieldsListids.join(',');
                    }
                    formData.otherData.tableColumns.forEach(element => {
                        if (element.type !== 'divider' && element.type !== 'subform' && element.type !== 'divider' && selectedFields.indexOf(element.id) !== -1 &&
                             element.type !== 'file' && element.type !== 'archive' && element.id !== 'appCreatedByDate' && element.id !== 'appCreatedByName') {
                            fieldsList.push(element);
                        }
                    });
                    this.refFormTableHtmlArray = [];
                    let tr = '<tr><td colspan="' + fieldsList.length + '">' + element.modelName + '</td></tr>';
                    let td = '';
                    fieldsList.forEach(item => {
                        td += '<td>' + item.label + '</td>';
                    });
                    tr += '<tr>' + td + '</tr>';
                    let valuesData = formData.data;
                    if (valuesData.length > 0) {
                        valuesData.forEach(str => {
                            let obj = JSON.parse(str);
                            let subTd = '';
                            fieldsList.forEach(cur => {
                                subTd += '<td>' + this.getSubFormValues(obj, cur) + '</td>';
                            });
                            tr += '<tr>' + subTd + '</td>';
                        });
                        let refFormTableHtml = {refFormTableHtml: tr};
                        this.refFormTableHtmlArray.push(refFormTableHtml);
                    }
                });
            }
            loading.close();
        },
        getSubFormValues (values, cur) {
            let id = cur.id;
            if (cur.type === 'select' || cur.type === 'category' || cur.type === 'file' || cur.type === 'process' || cur.type === 'address' || cur.type === 'cascader' || cur.type === 'role') {
                id = id + '-view';
            } else if (cur.type === 'user') {
                id = id + '-user';
            } else if (cur.type === 'dictionary' || cur.type === 'businessTree' || cur.type === 'department') {
                id = id + '-tree';
            } else if (cur.type === 'link') {
                let linkTable = values[id];
                if (linkTable) {
                    let linkId = linkTable.tableColumns[0].id;
                    let linkTableData = linkTable.tableData[0];
                    return linkTableData[linkId] === undefined ? '' : linkTableData[linkId];
                }
            }
            if (values[id]) {
                return values[id];
            } else {
                return '';
            }
        },
        getFormValues (cur) {
            let id = cur.id;
            if (cur.type === 'select' || cur.type === 'category' || cur.type === 'file' || cur.type === 'process' || cur.type === 'address' || cur.type === 'cascader' || cur.type === 'role') {
                if(cur.type === 'category' && cur.options.config.type === 'multi'){
                    let arr = cur.options.config.options;
                    let arrView=[];
                    for(let i=0;i<arr.length;i++){
                        let obj = arr[i];
                        if(this.formInfo.values[id].indexOf(obj.value) !== -1){
                            arrView.push(obj.title);
                        }
                    }
                    this.formInfo.values[id + '-view']=arrView.join(',');
                }
                id = id + '-view';
            } else if (cur.type === 'user') {
                id = id + '-user';
            } else if (cur.type === 'dictionary' || cur.type === 'businessTree' || cur.type === 'department') {
                id = id + '-tree';
            } else if (cur.type === 'link') {
                let linkTable = this.formInfo.values[id];
                if (linkTable) {
                    let linkId = linkTable.tableColumns[0].id;
                    let linkTableData = linkTable.tableData[0];
                    return linkTableData[linkId] === undefined ? '' : linkTableData[linkId];
                }
            }
            if (this.formInfo.values[id]) {
                return this.formInfo.values[id];
            } else {
                return '';
            }
        },
        async handelSelectVal (key, field) {
            if (!key) {
                return;
            }
            let obj = {};
            obj = field.options.config.options.find((item) => {
                return item.value === key;
            });
            if (obj && obj.assignmentFieldValue) {
                this.formInfo.values[obj.assignmentFieldId] = obj.assignmentFieldValue;
            }
            // this.formInfo.values[field.formField] = key;
            // this.formInfo.values[field.formField + '-view'] = key;
            // this.formField = key;
            if ((field.ext2 && field.ext2 === '1') || (obj && !obj.ext3)) { // 被选中作为级联组件，就不继续进行级联处理了
                return;
            }
            let showFieldArray = [];
            let hidenFieldArray = [];
            for (let i = 0; i < field.options.config.options.length; i++) {
                let cur = field.options.config.options[i];
                if (cur && cur.ext3) {
                    if (cur.value === this.formInfo.values[field.id]) {
                        let extsIds = cur.ext3.split(',');
                        for (let j = 0; j < extsIds.length; j++) {
                            let id = extsIds[j];
                            showFieldArray.push(id);
                        }
                    } else {
                        let extsIds = cur.ext3.split(',');
                        for (let j = 0; j < extsIds.length; j++) {
                            let id = extsIds[j];
                            hidenFieldArray.push(id);
                        }
                    }
                }
            }
            this.isHidenField(hidenFieldArray);
            this.isShowField(showFieldArray);
        },
        isHidenField (fieldArray) {
            if (fieldArray.length > 0) {
                this.formInfo.fieldsList.forEach(item => {
                    for (let i = 0; i < fieldArray.length; i++) {
                        let cur = fieldArray[i];
                        if (item.id === cur) {
                            item.isView = false;
                            this.formInfo.values[item.id + '-casDefautShow'] = false;
                        }
                    }
                });
            }
        },
        isShowField (fieldArray) {
            if (fieldArray.length > 0) {
                let formViewMap = null;
                // if (this.taskInstance && this.taskInstance.formObj && this.taskInstance.formObj.hasOwnProperty('formFieldsViewMap')) {
                //     formViewMap = this.taskInstance.formObj.formFieldsViewMap[this.formId];// 查看字段
                // }
                for (let i = 0; i < fieldArray.length; i++) {
                    let cur = fieldArray[i];
                    this.formInfo.fieldsList.forEach(item => {
                        if (item.id === cur && (!formViewMap || (formViewMap && formViewMap[cur]))) {
                            item.isView = true;
                            this.formInfo.values[item.id + '-casDefautShow'] = true;
                        }
                    });
                }
            }
        },
        showApprovalRecord () {
            // console.log(this.showApprovalInfo);
        }
    }
};
</script>

<style lang="less">
.printContentBox{
    width: 100%;
    margin-top: 26px;
    // border: 1px solid #333;
    .printFormName{
        height: 40px;
        line-height: 40px;
        font-size: 20px;
        text-align: center !important;
        font-weight: 500;
    }
    .printFormTable{
        width: 100%;
        .twoCells{
            width: 100%;
            .tdLabel{
                width: 10%;
            }
            .tdValue{
                width: 40%;
            }
        }
        .threeCells{
            .tdLabel{
                width: 10%;
            }
            .tdValue{
                width: 28%;
            }
        }
    }
    .printSubTableHtml{
        width: 100%;
        margin-top: 10px;
    }
    .printRefFormTableHtml{
        width: 100%;
        margin-top: 10px;
    }
    .printApprovalFormTable{
        width: 100%;
        margin-top: 10px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/PrintUtil/PrintFormHtml.vue